import { bootstrapApplication } from '@angular/platform-browser';
import { registerLucideIcons } from '@homepower-co/shared-ui/dist/collection/global/lucide.js';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

async function bootstrap() {
  await registerLucideIcons();

  if ('serviceWorker' in navigator) {
    if (environment.production) {
      window.addEventListener('load', () => {
        navigator.serviceWorker
          .register('/service-worker.js', {
            updateViaCache: 'none',
          })
          .then((registration) => {
            registration.addEventListener('updatefound', () => {
              registration.installing?.postMessage({ type: 'SKIP_WAITING' });
            });

            registration.waiting?.postMessage({ type: 'SKIP_WAITING' });

            document.addEventListener('visibilitychange', () => {
              registration.active?.postMessage({
                type: 'VISIBILITY_CHANGE',
                visible: document.visibilityState === 'visible',
              });
            });
          })
          .catch((error) => {
            console.error('[App] Error registering SW:', error);
          });
      });
    } else {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((r) => r.unregister());
      });
    }
  }

  await bootstrapApplication(AppComponent, appConfig);
}

bootstrap().catch((err) => console.error(err));
